import { api } from "../lib/api";

export const list = () => api.get("/users").then((r) => r.data);
export const create = (payload) => api.post("/users", payload).then((r) => r.data);
export const update = (id, payload) => api.put(`/users/${id}`, payload).then((r) => r.data);
export const remove = (id) => api.delete(`/users/${id}`).then((r) => r.data);

export const unlock = (id) => api.post(`/users/${id}/unlock`).then((r) => r.data);
